import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Translate from "../Translate"

/**
 * This component renders an external link as <a>
 *
 * @param {string} className to make styling easier
 * @param {string} link this is the link to which the link will redirect
 * @param {node} children this is the text or element that it is rendered inside the link
 * @param {function} onClick the function to be called when the link is clicked
 * @param {bool} hideChildren this param makes possible to display or not the children in case the link is not defined
 * @returns {component}
 */
const ExternalLink = ({
  className,
  children,
  accessibilityText,
  link = null,
  onClick = _.noop,
  hideChildren = false,
  isAccessible = true,
  ...rest
}) => {
  if (!_.isEmpty(link)) {
    const accessibilitySuffix = isAccessible
      ? "accessAccessibleLinkOpensInNewTab"
      : "accessNonAccessibleLinkOpensInNewTab"
    return (
      <div className={classNames("oj-external-link", className)}>
        <a
          target="_blank"
          href={link}
          onClick={onClick}
          rel="noopener noreferrer"
          aria-describedby={accessibilityText}
          {...rest}
        >
          {children}
          <span className="accessibility-tag">
            <Translate id={accessibilitySuffix} />
          </span>
        </a>
      </div>
    )
  }
  return _.isEmpty(link) && hideChildren ? null : children
}

ExternalLink.propTypes = {
  accessibilityText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  children: PropTypes.node,
  onClick: PropTypes.func,
  hideChildren: PropTypes.bool,
  isAccessible: PropTypes.bool
}

export default ExternalLink
